import { replace } from 'lodash';

/**
 * Trims trailing slashes from a URL.
 * @param url - The URL to trim.
 * @returns The trimmed URL.
 */
export function trimTrailingSlash(url: string) {
  return replace(url, /\/+$/, '');
}
